import gql from "graphql-tag";

export const MY_TIMESHEET_GET_TIMESHEET_LIST = gql`
  query listMysheetTimesheets(
    $contractId: String
    $endTime: Date
    $page: Int
    $pageSize: Int
    $periodEnd: Date
    $periodStart: Date
    $role: String
    $roleFilters: RoleFilterInput
    $searchField: String
    $searchText: String
    $sort: String
    $sortDirection: String
    $startTime: Date
    $state: String
    $typeFilters: TypeFilterInput
  ) {
    listMysheetTimesheets(
      contractId: $contractId
      endTime: $endTime
      page: $page
      pageSize: $pageSize
      periodEnd: $periodEnd
      periodStart: $periodStart
      role: $role
      roleFilters: $roleFilters
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      sortDirection: $sortDirection
      startTime: $startTime
      state: $state
      typeFilters: $typeFilters
    ) {
      _id
      name
      description
      contractId
      startTime
      endTime
      validFrom
      validTo
      projectId
      projectName
      projectColor
      clientId
      clientName
      clientColor
      costId
      costName
      costColor
      cost
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      state
      messageCount
      costBillable
    }
  }
`;
